import { UserInfo } from 'nvzn-models';

export function getFormattedFullName(userInfo: UserInfo): string {
  return `${userInfo.lastName}, ${userInfo.firstName}`;
}
